<template>
  <div class="backlog-workpackage-wrapper" v-if="!$store.state.View.takt_time_filter.active || (wbworkpackage.position > $store.state.View.takt_time_filter.start && wbworkpackage.position < $store.state.View.takt_time_filter.end)"
    :style="`
      width: ${width};
      height: calc((var(--workpackage_height) + 2px) * var(--taktplan_zoom) * ${wbworkpackage.height} ${wbworkpackage.height === 0.5?'- 2px * var(--taktplan_zoom)':''});
      top: calc((var(--workpackage_height) + 2px) * var(--taktplan_zoom) * 0.5 * ${wbworkpackage.y_index} + 2px * var(--taktplan_zoom) * ${wbworkpackage.y_index});
      left: calc((${$store.state.View.takt_time_filter.active ? wbworkpackage.position - 1- $store.state.View.takt_time_filter.start - 1 : wbworkpackage.position - 1} * (var(--workpackage_width) + 8px) ${moving_position?`+ ${difference} * 1px`:''}) * var(--taktplan_zoom));
      ${moving?'transition: none; z-index: 100;':''}
      ${wbworkpackage.add_wp?'z-index: 200;':''}
      ${wbworkpackage.is_open?'outline: 1px solid white;':''}
    `"
      @mouseover="hover_backlog = true"
      @mouseleave="hover_backlog = false"
    >
    <template v-if="!wbworkpackage.add_wp && isEditMode">
      <div class="backlog-workpackage-activators backlog-workpackage-activator-position">
        <Activator
          class="self-centered"
          @mousedown.native="activatorMouseDown({key: 'position', evt: $event})"
        />
      </div>
      <div class="backlog-workpackage-activators backlog-workpackage-activator-length">
        <Activator
          class="self-centered"
          @mousedown.native="activatorMouseDown({key: 'length', evt: $event})"
        />
      </div>
    </template>
    <div
      :class="`backlog-workpackage ${workpackage_color}`"
      @click.prevent.stop="$emit('clickWorkpackage')"
      @dblclick.prevent.stop="$emit('dblclickWorkpackage', $event)"
      >
      <!-- <div :class="`backlog-workpackage-color ${wbworkpackage.color}`"/> -->
      <v-icon v-if="wbworkpackage.add_wp">add</v-icon>
      <TIcon
        v-else
        :name="getNewIcon(wbworkpackage.icon)"
        :medium="wbworkpackage.height === 1?true:undefined"
        :small="wbworkpackage.height === 1?undefined:true"
        :color="wbworkpackage.textcolor ? wbworkpackage.textcolor : 'black'"
        class="svg-icon"
        />
      <div
        class="workpackage-token font-weight-light ml-1"
        :style="`
          ${wbworkpackage.textcolor?`color: ${wbworkpackage.textcolor};`:'color: black;'}
        `"
        >
        {{wbworkpackage.token}}
      </div>
      <StandardBadge
        class="backlog-workpackage-badge cursor-pointer"
        v-if="(wbworkpackage.status !== 'none' || wbworkpackage.stop_status !== 'none') && isShowStatusBadges"
        :icon="wbworkpackage.stop_status !== 'none'?(wbworkpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === wbworkpackage.status).icon"
        color="white"
        :content_color="wbworkpackage.stop_status !== 'none' ? 'red':'black'"
      />
      <StandardBadgeMini
        v-else-if="(wbworkpackage.status !== 'none' || wbworkpackage.stop_status !== 'none')"
        style="top: 0px"
        />
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapState, mapActions } from 'vuex';

  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
  import StandardBadgeMini from '@/components/StandardComponents/StandardBadgeMini.component.vue'

  export default {
    props: ['wbworkpackage', 'wbline_id', 'zoom', 'isEditMode', 'project_length', 'color'],
    components: {
      TIcon,
      Activator,
      StandardBadge,
     StandardBadgeMini,
    },
    data: () => ({
      initial_mouse_x: 0,
      initial_taktplan_scroll_x: 0,
      moving: false,
      moving_position: false,
      moving_length: false,
      difference: 0,
      hover_backlog: false,
    }),
    mounted(){
      window.addEventListener('keyup', this.onKeyUp)
    },
    unmounted(){
      window.removeEventListener('keyup', this.onKeyUp)
    },
    computed: {
      ...mapGetters('Project', [
        'getStatusArray',
        'isShowStatusBadges',
      ]),
      ...mapGetters('WorkPackage', [
        'getNewIcon',
      ]),
      ...mapState('View', [
        'taktplan_zoom',
      ]),
      workpackage_color() {
      if (this.color) {
        return this.color;
      } else if (this.wbworkpackage && !this.wbworkpackage.color.includes('lighten') && !this.wbworkpackage.color.includes('darken')){
        return `${this.wbworkpackage.color} lighten-1`;
      } else if (this.wbworkpackage) {
        return `${this.wbworkpackage.color}`;
      } else {
        return false;
      }
    },
      width() {
        if (this.wbworkpackage.length === 1) {
          return `calc(((var(--workpackage_width) + 2px) * ${this.wbworkpackage.length} ${this.moving_length?`+ ${this.difference} * 1px`:''}) * var(--taktplan_zoom))`
        } else {
          return `calc(((var(--workpackage_width) + 2px) * ${this.wbworkpackage.length} + (6px * ${this.wbworkpackage.length-1}) ${this.moving_length?`+ ${this.difference} * 1px`:''}) * var(--taktplan_zoom) )`
        }
      },
      taktplan_el() {
        return document.getElementById('taktplan');
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
      ]),
      activatorMouseDown(payload) {
        this.initial_mouse_x = payload.evt.x;
        this.initial_taktplan_scroll_x = this.taktplan_el.scrollLeft;
        this[`moving_${payload.key}`] = true;
        this.moving = true;

        document.body.addEventListener('mousemove', this.activatorMouseMove);
        document.body.addEventListener('mouseup', this.activatorMouseUp);

        document.getElementById(`wbline${this.wbline_id}`).style.width =
          `${document.getElementById(`wbline${this.wbline_id}`).clientWidth + window.innerWidth}px`;
      },
      activatorMouseUp() {
        this.moving = false;

        let waggon_width_string = getComputedStyle(document.body).getPropertyValue('--waggon_width');
        let waggon_width = parseInt(waggon_width_string.substring(0, waggon_width_string.length-2)) + parseInt(4);

        let column_difference = Math.round((this.difference * this.taktplan_zoom) / (waggon_width * this.taktplan_zoom));


        if (this.moving_length && column_difference !== 0) {
          this.$emit('changeLength', column_difference)
        } else if (this.moving_position && column_difference !== 0) {
          this.$emit('changePosition', column_difference)
        }

        this.moving_position = false;
        this.moving_length = false;
        this.difference = 0;

        document.body.removeEventListener('mousemove', this.activatorMouseMove);
        document.body.removeEventListener('mouseup', this.activatorMouseUp);

        document.getElementById(`wbline${this.wbline_id}`).style.width =
        `calc((${this.project_length + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom))`;

      },
      activatorMouseMove(evt) {
        let scroll_difference = this.initial_taktplan_scroll_x - this.taktplan_el.scrollLeft;
        this.difference = parseInt(evt.x - this.initial_mouse_x - scroll_difference) / this.taktplan_zoom;
        // if (this.moving_length && difference < 0) {
        //   this.difference = 0;
        // } else {
        //   this.difference = difference;
        // }
      },
      onKeyUp(e){
        if (this.hover_backlog && (!document.activeElement || (document.activeElement && !['TEXTAREA', 'INPUT'].includes(document.activeElement.tagName)))) {
          const reg = new RegExp('^[0-9]$');
          const status_lookup = {
            '1': 'ready',
            '2': 'started',
            '3': 'done',
            '4': 'checked',
            '5': 'closed',
            '0': 'none',
          }

          if(reg.test(e.key)) {
            let value = parseInt(e.key);
            this.updateUObject({
                url: [
                  {projects: 0},
                  {wbgroups: 0},
                  {wblines: 0},
                  {wbworkpackages: this.wbworkpackage.id}
                ],
                update: {
                  status: status_lookup[value]
                }
            });
          }
        }
      },
    }
  }
</script>
<style>
  .backlog-workpackage-wrapper {
    position: absolute;
    width: calc((var(--workpackage_width) + 2px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 2px) * var(--taktplan_zoom));
    align-items: center;
    margin: calc(2px * var(--taktplan_zoom)) calc(3px * var(--taktplan_zoom));
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
  .backlog-workpackage {

    position: relative;
    display: flex;
    height: 100%;
    align-items: center;
    /* justify-content: center; */
    padding-left: 3px;
    width: 100%;
    height: 100%;
    /* border-radius: calc(3px * var(--taktplan_zoom)) !important; */

    cursor: pointer;
  }
  .backlog-workpackage-color {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 7px;
  }
  .backlog-workpackage-wrapper:hover .backlog-workpackage-activators {
    display: flex;
  }
  .backlog-workpackage-wrapper:hover .backlog-workpackage-badge {
    display: none;
  }
  .workpackage-token {
    font-size: calc(12px * var(--taktplan_zoom));
    user-select: none;
  }
  .svg-icon {
    zoom: var(--taktplan_zoom);
  }
  .backlog-workpackage-activators {
    position: absolute;
    display: none;
    cursor: col-resize;
  }
  .backlog-workpackage-activator-position {
    left: 0px;
    bottom: 0px;
  }
  .backlog-workpackage-activator-length {
    right: 0px;
    top: 50%;
  }
  .backlog-workpackage-badge {
    display: flex;
  }
</style>
